/**
 * Number of passengers a promotional code discount applies to.
 *
 * The per-code discount is granted **per passenger, babies excluded**: a lap
 * infant (< 2y) does not occupy a paid seat, so no discount is granted for it.
 * Every other category (adults, seniors, youngsters, children/`infants`) counts.
 *
 * Shared by the server (discount computation) and the web/back-office UIs
 * (per-passenger breakdown display) so the rule stays in one place.
 */
export function countBillablePassengers(passengersCount) {
    if (!passengersCount)
        return 0;
    return ((passengersCount.adults ?? 0) +
        (passengersCount.infants ?? 0) +
        (passengersCount.seniors ?? 0) +
        (passengersCount.youngsters ?? 0));
}
/**
 * Remise unitaire à afficher sous le montant total, ou `null` quand il n'y a rien
 * à ventiler.
 *
 * Rendu `null` en `PER_BOOKING` (la remise porte le dossier entier, la diviser par
 * les voyageurs raconterait un calcul qui n'a pas eu lieu), pour un seul voyageur,
 * et quand la division ne tombe pas juste — ce dernier cas signe une remise rabotée
 * par le sous-total, dont la ventilation serait fausse.
 *
 * `scope` vient du dossier (snapshot), jamais du réglage global : un dossier ancien
 * doit continuer d'afficher la ventilation qui a servi à le calculer.
 */
export function promoDiscountUnitCents(totalDiscountCents, billablePassengerCount, scope) {
    if ((scope ?? 'PER_PASSENGER') !== 'PER_PASSENGER')
        return null;
    if (billablePassengerCount <= 1)
        return null;
    if (totalDiscountCents % billablePassengerCount !== 0)
        return null;
    return totalDiscountCents / billablePassengerCount;
}
